(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.decorativeInitials = {
    attach(context) {
      const elements = once(
        'decorative-initials',
        '.field--name-field-text-overlay',
        context
      );

      elements.forEach((element) => {
        const walker = document.createTreeWalker(
          element,
          NodeFilter.SHOW_TEXT,
        );

        const textNodes = [];

        while (walker.nextNode()) {
          textNodes.push(walker.currentNode);
        }

        textNodes.forEach((node) => {
          const text = node.textContent;

          // Match the first Unicode letter of each word.
          const pattern = /(?<![\p{L}\p{N}])\p{L}/gu;

          if (!pattern.test(text)) {
            return;
          }

          pattern.lastIndex = 0;

          const fragment = document.createDocumentFragment();
          let lastIndex = 0;

          for (const match of text.matchAll(pattern)) {
            const index = match.index;

            fragment.append(
              document.createTextNode(text.slice(lastIndex, index))
            );

            const span = document.createElement('span');
            span.className = 'decorative-initial';
            span.textContent = match[0];

            fragment.append(span);

            lastIndex = index + match[0].length;
          }

          fragment.append(
            document.createTextNode(text.slice(lastIndex))
          );

          node.replaceWith(fragment);
        });
      });
    }
  };
})(Drupal, once);
